import { useContext } from "react";
import { TabNavigationContext } from "../../../../Shared/contexts/TabNavigationContext";
import navigationPages from "./NavigationPages";

import { Tabs } from "antd";

function NavigationTabs({ticket, disabled}: {ticket: any, disabled: boolean}) {
  const { activeTab, setActiveTab } = useContext(TabNavigationContext);
  return (
    <Tabs
      className="h-3/4"
      type="card"
      items={navigationPages({ticket, disabled})}
      activeKey={activeTab}
      onChange={(e) => setActiveTab?.(e)}
    />
  );
}

export default NavigationTabs;
